package org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_sub_account


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApaleoSubAccounts(
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("salesGroupIds")
    val salesGroupIds: List<String?>?,
    @SerialName("type")
    val type: String?,
    @SerialName("__typename")
    val typename: String?
)